import { AlmeState } from "@alme/ui-web/wireup/AlmeState";
import { Store } from "redux";
import { AlightCustomSettingsType } from "../../settings/alight-custom-settings";
import { AlightStateType } from "../../types/alight-state";
import {checkCounterAreaVisibility} from '../lib-alight-library/lib-alight-library'
export default class InputBoxCounterMutator {
    _settings: AlightCustomSettingsType;
    _store: Store<AlightStateType> | undefined;

    constructor(settings: AlightCustomSettingsType) {
        this._settings = settings;
    }

    initialize(store: Store<AlightStateType>) {
        this._store = store;
    }

    getMutator(){
        return (parameters = {}) => {
            const language = this._store?.getState().Conversation.Language;
            const ivaWindow = <HTMLElement> document.getElementsByClassName('alme--window ui-draggable')[0];
            if (ivaWindow?.offsetTop != 0) {
                checkCounterAreaVisibility(language, this._store?.getState(), this._settings);
            }
            return parameters;
        };
    }
}


// WEBPACK FOOTER //
// ./modules/mutators/inputCounterMutator.ts